import {defineToolRegistryManifest} from '../../types/base-tool-types';
import {z} from 'zod';
import dedent from 'dedent';
import {elementIdSchema} from '../../schemas';

const toolName = 'get-form-settings' as const;

const argumentZod = z.object({
  elementId: elementIdSchema.describe(
    'The ID of the Form element to get settings from. Must be a FormForm or FormWrapper element.'
  ),
});

export const getFormSettingsTool = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Get form settings',
  llmTool: {
    name: toolName,
    description: dedent`
      Retrieve comprehensive settings of a form element. Returns a FormSettings
      object containing the form's state (normal/success/error), name, redirect URL,
      action URL, and HTTP method (get/post). Only works with Form elements (FormForm
      or FormWrapper types). The settings control form behavior, submission handling,
      and post-submission actions. Use this to understand current form configuration
      before making changes.`,
    inputSchema: argumentZod,
  },
  type: 'designer',
  confirmBeforeExecuting: false, // Read-only operation
  timeout: 30000, // 30 seconds for retrieving form settings
});
